import React from "react";
const OrderInformation = ({ iconSrc, icon: Icon, title, content, iconBg }) => {
  return (
    <>
      {" "}
      <div className="elem__order">
        <div className="order__image">
          <span
            className="order__icon-circle"
            style={iconBg ? { backgroundColor: iconBg } : undefined}
          >
            {Icon ? (
              <Icon size={20} />
            ) : (
              <img className="topUp" src={iconSrc} alt="floaticon" />
            )}
          </span>
        </div>
        <div className="order__info">
          <span>{title}</span>
          <p>{content}</p>
        </div>
      </div>
    </>
  );
};
export default OrderInformation;
